export const ADMIN_ROLE = "admin";
export const USER_PERSIST_CACHE = "user_persist_cache";
